:host {
  .hide {
    display: none !important;
  }

  .tech-emergency {
    &__container {
      .support-ik {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        img {
          width: 24px;
          height: 24px;
          margin-right: 8px;
        }
        span {
          font-size: 16px;
          font-weight: 600;
          color: #333333;
          color: var(--font-primary);
        }
      }

      .emergency-block {
        background: white;
        background: var(--bg-primary);
        border-radius: 10px;
        padding: 24px;

        &__title {
          font-size: 16px;
          font-weight: 500;
          color: #333333;
          color: var(--font-primary);
          margin-bottom: 18px;
        }

        &__opening-time {
          display: flex;
          gap: 16px;
          div {
            display: flex;
            gap: 6px;
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            color: var(--font-secondary);
            margin-bottom: 18px;
          }
        }

        &__info-box {
          display: flex;
          border-radius: 10px;
          background-color: #f4f6fd;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          color: var(--font-primary);
          padding: 16px;
          box-sizing: border-box;
          margin-bottom: 28px;
          img {
            width: 16px;
            height: 16px;
            object-fit: contain;
            margin-right: 10px;
            filter: invert(54%) sepia(44%) saturate(7155%) hue-rotate(183deg) brightness(102%)
              contrast(109%);
            filter: var(--icon-blue);
          }
          p {
            margin: 0;
          }
        }

        &__valid-reasons {
          .reasons-list {
            margin-bottom: 20px;
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            color: var(--font-secondary);
            strong {
              font-weight: 700;
              color: #333333;
              color: var(--font-primary);
            }
            &__line {
              display: flex;
              gap: 16px;
              margin-bottom: 20px;
              font-size: 14px;
              font-weight: 400;
              color: #333333;
              color: var(--font-primary);
              img {
                width: 16px;
                height: 16px;
              }
            }
          }
        }

        &__callback-time {
          width: fit-content;
          background-color: #f4f6fd;
          border-radius: 10px;
          padding: 8px;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          color: var(--font-primary);
          margin-bottom: 32px;
          strong {
            font-weight: 500;
          }
        }

        &__confirmation-checkbox {
          margin-bottom: 18px;
          label {
            display: flex;
            gap: 8px;
            font-size: 14px;
            font-weight: 500;
            cursor: pointer;
            color: #333333;
            color: var(--font-primary);
          }
        }

        &__submit {
          button {
            width: 100%;
            padding: 12px 16px;
            border: 0;
            border-radius: 4px;
            font-size: 14px;
            font-weight: 400;
            cursor: pointer;
            transition: all 0.3s;
            background-color: #f44336;
            color: #fff;
            &[disabled] {
              opacity: 0.5;
              cursor: unset;
            }
          }
        }
      }
    }

    /* -------------------------------------------------------------------------- */
    /*                                  FULL MODE                                 */
    /* -------------------------------------------------------------------------- */
    &--full {
      .support-ik {
        span {
          color: white;
        }
      }
    }
  }
}
